export const mockData = {
    hero: {
        headline: "Smart Appointment Booking for Doctors & Patients",
        subheadline: "Book. Scan. Track. Manage.",
        ctaButtons: {
            primary: "Download Beta APK",
            secondary: "Join as Tester"
        }
    },

    qrFeature: {
        title: "Scan & Book Instantly",
        description: "Simply scan the doctor's QR code to view their profile and book appointments in seconds. No more long waiting times or complicated booking processes.",
        features: [
            "Instant doctor profile access",
            "Real-time slot availability",
            "Quick appointment booking",
            "Digital health card"
        ]
    },
    campFeature: {
        title: "Medical Camp Management",
        description: "Create and manage medical camps effortlessly. Allow multiple doctors to join and let patients register seamlessly.",
        features: [
            "Create medical camps",
            "Multi-doctor collaboration",
            "Patient registration",
            "Real-time notifications"
        ]
    },
    privateCaseFeature: {
        title: "Secure Case Management",
        description: "Doctors can maintain comprehensive patient histories, visit notes, and treatment plans in a secure, encrypted environment.",
        features: [
            "Patient history tracking",
            "Detailed visit notes",
            "Treatment plan management",
            "End-to-end encryption"
        ]
    },
    patientTracker: {
        title: "Comprehensive Health Tracking",
        description: "Track your health journey with intelligent reminders and analytics powered by AI.",
        trackers: [
            {
                name: "Water Intake",
                icon: "Droplets",
                description: "Stay hydrated with smart reminders"
            },
            {
                name: "Medicine Reminders",
                icon: "Pill",
                description: "Never miss a dose again"
            },
            {
                name: "Exercise Tracker",
                icon: "Activity",
                description: "Monitor your fitness progress"
            },
            {
                name: "Diet Tracker",
                icon: "Apple",
                description: "Track nutrition and meals"
            },
            {
                name: "Mental Wellness",
                icon: "BookOpen",
                description: "Mindfulness and reading tracker"
            }
        ]
    },
    voiceAssistant: {
        title: "GoDoc Voice Assistant",
        description: "Your personal health companion. Just speak, and let GoDoc AI handle the rest.",
        features: [
            "Voice-activated reminders",
            "Natural conversation",
            "Smart health insights",
            "Hands-free interaction"
        ]
    },
    security: {
        title: "Enterprise-Grade Security",
        description: "Your health data deserves the highest level of protection.",
        features: [
            {
                title: "Firebase Backend",
                description: "Powered by Google's secure infrastructure",
                icon: "Shield"
            },
            {
                title: "Cloudinary Storage",
                description: "HIPAA-compliant image storage",
                icon: "Cloud"
            },
            {
                title: "End-to-End Encryption",
                description: "Your data is encrypted at rest and in transit",
                icon: "Lock"
            }
        ]
    },
    finalCTA: {
        title: "Start Using GoDoc Today",
        description: "Join thousands of doctors and patients revolutionizing healthcare management.",
        buttons: {
            primary: "Download Beta",
            secondary: "Join as Tester"
        }
    },
    footer: {
        sections: [
            {
                title: "Product",
                links: ["Features", "Security", "Download"]
            },
            {
                title: "Company",
                links: ["About", "Contact", "Careers"]
            },
            {
                title: "Legal",
                links: ["Privacy Policy", "Terms of Service", "HIPAA Compliance"]
            }
        ],
        copyright: "© 2026 GoDoc. All rights reserved."
    }
};

export const emailConfig = {
    serviceId: "YOUR_SERVICE_ID",
    templateId: "YOUR_TEMPLATE_ID",
    publicKey: "YOUR_PUBLIC_KEY"
};
